
// ====================
// components/ProjectsSection.js
// ====================

import React from 'react';
import { Github, } from 'lucide-react';

const ProjectsSection = () => {
  const projects = [
    {
      title: "Music Heatmap",
      description: "A social media app that uses geolocation to pin a user's chosen song to a location, creating a musical map of experiences.",
      technologies: ["React Native", "Firebase", "Spotify API", "Geolocation"],
      features: ["Real-time location pinning", "Spotify integration", "Social sharing", "Interactive map interface"],
      challenges: "Implementing real-time geolocation for free.",
      future: "Plans to add a messaging system.",
      github: "https://github.com/luciuskarki/MusicHeatMap.git",
    },
    {
      title: "Threaded TCP Chat System",
      description: "A multi-threaded client-server chat application built with Python that enables real-time communication over TCP sockets, supporting both broadcast and private messaging with concurrent user handling.",
      technologies: ["Python", "TCP Sockets", "Multithreading", "JSON Protocol", "Network Programming"],
      features: ["Real-time message broadcasting", "Private messaging system", "Concurrent client handling", "User authentication and session management"],
      challenges: "Implementing thread safe communication between multiple clients, and managing socket connections with proper cleanup and error handling.",
      future: "Plans to add file transfer capabilities, and a GUI.",
      github: "https://drive.google.com/file/d/1VQPijoa4Ov9zULiu1zOmSca7D1GsiEbl/view?usp=sharing",
    },

    {
      title: "Figure Skating Rescorer",
      description: "A scoring calculator designed to allow the user to evaluate figure skating routines and compute total performance scores according to official judging standards.",
      technologies: ["JavaScript", "HTML/CSS", "C++", "Full-Stack Development"],
      features: ["Interactive element input system", "Real time score calculation", "Official scoring algorithm implementation", "User friendly interface design"],
      challenges: "Accurately implementing complex figure skating scoring rules and creating seamless communication between frontend JavaScript and backend C++ processing.",
      future: "Plans to add support for multiple skating groups, such as pairs and ice dance, and to enhance the user interface for better usability.",
      github: "https://github.com/nicoleamaral37/CSI240_Final_NA.git",
    },
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h2>Featured Projects</h2>
        
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-header">
                <h3>{project.title}</h3>
                <div className="project-links">
                  <a href={project.github} className="project-link">
                    <Github size={20} />
                  </a>
                </div>
              </div>
              
              <p className="project-description">{project.description}</p>
              
              <div className="project-section">
                <h4>Technologies Used</h4>
                <div className="tech-tags">
                  {project.technologies.map((tech, techIndex) => (
                    <span key={techIndex} className="tech-tag">{tech}</span>
                  ))}
                </div>
              </div>
              
              <div className="project-section">
                <h4>Key Features</h4>
                <ul className="feature-list">
                  {project.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>{feature}</li>
                  ))}
                </ul>
              </div>
              
              <div className="project-section">
                <h4>Challenges</h4>
                <p className="project-challenges">{project.challenges}</p>
              </div>
              
              <div className="project-section">
                <h4>Future Directions</h4>
                <p className="project-future">{project.future}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;